import { TSocketTradeAreaTickersData } from './../index'
//登录
import { TTimezone } from 'core/types'

export const Socket_Signin = 'signin'
//
//盘口和深度
export const Socket_Topic_Trade_Depth = 'market.v2.{{symble}}.trade.depth.{{depthNumber}}'
export const Socket_Topic_Trade_KLINE = 'market.v2.{{symble}}.kline.{{granularity}}'
//
// //实时成交
export const Socket_Topic_Trade_Detail = 'market.v2.{{symble}}.trade.detail'
//
// //订阅交易区（行情）数据
export const Socket_Topic_Trade_Area_Tickers = 'market.v2.trade.area.tickers'
//
// //本周明星币
// export const Socket_Topic_Star_Coin = 'market.v2.trade.star.coin'

/**行情指标异动 */
export const Market_Abnormal = 'market.quote.index.monit'

/** 行情3.2 榜单推送 **/
//热门榜
export const Socket_Trade_Hot_Rank = 'market.v2.trade.hot.rank'
// export const Socket_Market_Trade_Hot_All_Tickers = 'market.v2.trade.hot.all'

//涨幅榜
export const Socket_Trade_Up_Tickers = 'market.v2.trade.up.tickers'
// export const Socket_Market_Trade_Up_All_Tickers = 'market.v2.trade.up.all'

//跌幅榜
export const Market_Trade_Down_Tickers = 'market.v2.trade.down.tickers'
export const Market_Trade_Down_All_Tickers = 'market.v2.trade.down.all'

//新币榜
export const Socket_Trade_Newlisting_Rank = 'market.v2.trade.newlisting.rank'
// export const Socket_Topic_newlisting_All_rank = 'market.v2.trade.newlisting.all'

//成交额榜
export const Socket_Trade_Amount_Rank = 'market.v2.trade.amount.rank'
export const Market_Trade_Recommend_Pair = 'market.v2.trade.recommend.pair'
// export const Socket_Market_Trade_Amount_All_Rank = 'market.v2.trade.amount.all'

//主流交易对
export const Socket_Trade_Main_Pair = 'market.v2.trade.main.pair'
// /**当前委托数据变化 */
export const Socket_Market_Trade_Entrust_Change = 'market.trade.entrust.change'
// /**币币用户资产变更 */
export const Socket_Market_Trade_Asset_Balance = 'market.trade.asset.balance'
//
// 指定交易对的24小时行情数据
export const Socket_Topic_Trade24h_tickers = 'market.v2.{{symble}}.24h.tickers'
// //行情异动
export const Socket_Market_Move_Change = 'market.quote.index.monit'

export const Socket_Live_Room_Playing = 'live.room.playing'

//
// /** 杠杆订阅 **/
// /**全仓杠杆资产变更 */
// export const Socket_Market_Cross_Asset_Balance = 'market.cross.asset.balance'
// /**逐仓杠杆资产变更 */
// export const Socket_Market_Isolated_Asset_Balance = 'market.isolated.asset.balance'
// /**全仓杠杆委托单 */
// export const Socket_Market_Trade_Cross_Entrust_Change = 'market.trade.cross.entrust.change'
// /**逐仓杠杆委托单 */
// export const Socket_Market_Trade_Isolated_Entrust_Change = 'market.trade.isolated.entrust.change'
// // 涨跌分布数据
// export const Socket_Market_ChgDistributions = 'market.quote.chg_distributions'
// // 专区币种数据
// export const Socket_Market_zones = 'market.quote.market_zones'
//
// //市场热力图
// export const Socket_Market_Market_Quote_Market_Heatmap = 'market.quote.market_heatmap'
//
// // C2C订单数量
// export const Socket_C2c_Order_Goingnum = 'c2c.order.goingnum'
//
// //多涨跌幅
// export const Socket_Market_Multichg_Tickers = 'multichg.tickers'

export type TSocketResponse = {
  code: number
  msg: string
  status: string
  ts: number
  ch: string
  [key: string]: any
}

export type TSocketTradeMainPairData = {
  tradeId: number
  cny: string
  totalamount: string
  last: string
  volume: string
  change: string
}

export type TSocketTradeAmountRankData = {
  tradeid?: number
  cny: string
  totalamount: string
  last: string
  volume: string
  change: string
  tradeId: number
  sellSymbol?: string
  buySymbol?: string
  totalAmount?: string
  imageUrl?: string
  isMarginTrade?: boolean
  marginRatio?: string
  isNew?: boolean
  hasChange?: string
}

type TCountdown = {
  d: string
  h: string
  m: string
  s: string
}
export type TTradeHotTickers = {
  tradeid: number
  isopen: string
  listingtime: number
  last: string
  cny: string
  volume: string
  change: string
  totalamount: string
  tradeId: number
  sellSymbol: string
  buySymbol: string
  isNew: boolean
  totalAmount: string
  listingTime: number
  imageUrl: string
  isMarginTrade: boolean
  marginRatio: string
  digit: string
  isOpen: string
  hasLine?: boolean
  countdown?: TCountdown
  hasChange?: string
}

export type TSocketTradeUpTickersData = {
  tradeid: number
  cny: string
  change: string
  last: string
  volume: string
  totalamount: string
  tradeId: number
  sellSymbol: string
  buySymbol: string
  totalAmount: string
  imageUrl: string
  isMarginTrade: boolean
  marginRatio: string
  isNew: boolean
  hasChange: string
}

export type TSocketTradeNewlistingRank = {
  tradeid: number
  isopen: string
  listingtime: number
  last: string
  cny: string
  volume: string
  change: string
  totalamount: string
  tradeId: number
  sellSymbol?: string
  buySymbol?: string
  isNew?: boolean
  totalAmount?: string
  listingTime?: number
  imageUrl?: string
  isMarginTrade?: boolean
  marginRatio?: string
  digit?: string
  isOpen?: string
  hasLine?: boolean
  countdown?: TCountdown
  hasChange?: string
}

export type TSocketTradeHotRankData = {
  tradeid: number
  cny: string
  totalamount: string
  last: string
  volume: string
  change: string
  tradeId: number
  sellSymbol?: string
  buySymbol?: string
  totalAmount?: string
  imageUrl?: string
  isMarginTrade?: boolean
  marginRatio?: string
  isNew?: boolean
  hasChange?: string
}

export type TSocketTrade24hTickerData = {
  tradeid: number
  high: string
  open: string
  low: string
  close: string
  volume: string
  change: string
  cny: string
  last: string
  netvalue: string
  amount: string
  isfiatconvert: boolean
}

export type TSocketMarketMoveChange = {
  createtime: string
  biztype: string
  contracttype: string
  liquidationdate: string
  indexkey: string
  indexbase: string
  tradecode: string
  tradeid: string
  movetime: string
  [key: string]: any
}

export type TSocketTradeDepthData = {
  bids: {
    biddataList: {
      buyinfoList: [string, string]
    }[]
  }
  asks: {
    askdataList: {
      sellinfoList: [string, string]
    }[]
  }
  last: string
  open: string
  cny: string
  netValue: string
  buyOrSellCnyPrice: string
  isfiatconvert: boolean
}

export type TSocketTradeDetailData = {
  amount: string
  direction: string
  price: string
  tradeid: number
  ts: number
}[]

export type TSocketTradeAreaTickersData = {
  /** 买1价 */
  buy: string
  /** 等价于人民币价格 */
  cny: string
  /** 杠杆倍数 */
  lever: string
  /** 最新价(未换算之前的价格) */
  last: string
  /** 变化率(涨跌幅)(负数表示跌,正数表示涨) */
  change: string
  /** 卖1价 */
  sell: string
  /** 成交量 */
  volume: string
  /** 交易id */
  tradeId: number
  /** 最高价 */
  high: string
  /** 最低价 */
  low: string
  /** 0 未开盘,1已开盘 */
  isOpen: string
  /** 开盘价 */
  open: string
}

export type TSocketLiveRoomPlaying = {
  id: number
  userId: number
  userName: string
  photo: string
  roomName: string
  lang: string
  show: string
  roomType: number
  tradeAmountLimit: string
  anchorPopular: number
  status: number
}

export type TSocketTradeKlineData = {
  amount: number
  close: number
  high: number
  low: number
  open: number
  time: number
  volume: number
}[]

export type SocketTypeMap = {
  [Socket_Trade_Main_Pair]: TSocketTradeMainPairData[]
  [Socket_Trade_Amount_Rank]: TSocketTradeAmountRankData[]
  [Socket_Trade_Up_Tickers]: TSocketTradeUpTickersData[]
  [Socket_Trade_Newlisting_Rank]: TSocketTradeNewlistingRank[]
  [Socket_Trade_Hot_Rank]: TSocketTradeAmountRankData[]
  [Socket_Signin]: {
    result: boolean
    curTime: number
  }
  [Socket_Topic_Trade24h_tickers]: TSocketTrade24hTickerData
  [Socket_Market_Move_Change]: TSocketMarketMoveChange
  [Socket_Topic_Trade_Depth]: TSocketTradeDepthData
  [Socket_Topic_Trade_Detail]: TSocketTradeDetailData
  [Socket_Topic_Trade_Area_Tickers]: TSocketTradeAreaTickersData[]
  [Socket_Live_Room_Playing]: TSocketLiveRoomPlaying[]
  [Socket_Market_Trade_Entrust_Change]: any
  [Socket_Market_Trade_Asset_Balance]: any
}

export type TypeSocketKey = keyof SocketTypeMap

const getHandlerData = (timezone: TTimezone) => {
  const timezoneString = timezone ? '.' + timezone : '' // 无比奇怪的方案
  return {
    [Socket_Trade_Main_Pair + timezoneString]: (data: TSocketResponse) => {
      return data.mainpair.listList as TSocketTradeMainPairData[]
    },
    [Socket_Signin]: (data: TSocketResponse) => {
      return {
        result: true,
        curTime: new Date().getTime(),
      }
    },
    // 成交额榜
    [Socket_Trade_Amount_Rank + timezoneString]: (data: TSocketResponse) => {
      return data.amtpair.listList as TSocketTradeAmountRankData[]
    },
    // 涨幅榜
    [Socket_Trade_Up_Tickers + timezoneString]: (data: TSocketResponse) => {
      return data.uppair.listList as TSocketTradeUpTickersData[]
    },
    // 跌幅榜
    [Market_Trade_Down_Tickers + timezoneString]: (data: TSocketResponse) => {
      return data.downpair.listList as TSocketTradeUpTickersData[]
    },
    // 推荐榜
    [Market_Trade_Recommend_Pair + timezoneString]: (data: TSocketResponse) => {
      return data.recommendpair.listList as TSocketTradeUpTickersData[]
    },
    // 热门榜
    [Socket_Trade_Hot_Rank + timezoneString]: (data: TSocketResponse) => {
      return data.tradehotlisting.listList as TSocketTradeHotRankData[]
    },
    //新币榜
    [Socket_Trade_Newlisting_Rank + timezoneString]: (data: TSocketResponse) => {
      return data.newlistingpair.listList as TSocketTradeNewlistingRank[]
    },
    //指定交易对的24小时行情数据
    [Socket_Topic_Trade24h_tickers + timezoneString]: (data: TSocketResponse) => {
      return data.tradetickervo as TSocketTrade24hTickerData
    },
    //行情异动
    [Socket_Market_Move_Change]: (data: TSocketResponse) => {
      return data.marketmonit as TSocketMarketMoveChange
    },
    //盘口和深度
    [Socket_Topic_Trade_Depth]: (data: TSocketResponse) => {
      const depthObject = {
        asks: [],
        bids: [],
        buyOrSellCnyPrice: data.tradedepthvo.buyOrSellCnyPrice,
        cny: data.tradedepthvo.cny,
        last: data.tradedepthvo.last,
        open: data.tradedepthvo.open,
        isfiatconvert: data.tradedepthvo.isfiatconvert,
        netValue: data.tradedepthvo.netValue,
      }
      data.tradedepthvo.asks.askdataList.forEach((item) => {
        depthObject.asks.push(item.sellinfoList)
      })
      data.tradedepthvo.bids.biddataList.forEach((item) => {
        depthObject.bids.push(item.buyinfoList)
      })
      // depthObject.asks = depthObject.asks.reverse()
      return depthObject as TSocketTradeDepthData
    },
    //订阅交易区（行情）数据
    [Socket_Topic_Trade_Area_Tickers + timezoneString]: (data: TSocketResponse) => {
      return data.tradeareapair.listList as TSocketTradeAreaTickersData[]
    },
    //直播
    [Socket_Live_Room_Playing]: (data: TSocketResponse) => {
      return data.liveroomlist.listList as TSocketLiveRoomPlaying
    },
    //k线
    [Socket_Topic_Trade_KLINE]: (data: TSocketResponse) => {
      let kLineArray = []
      data.klinelist.listList.forEach((item, i) => {
        kLineArray.push(item.klinedataList)
      })
      const granularity = data.ch.split('.')[4]
      //用K线的最新价更新外面的最新价，解决后端推送不及时问题
      // store.state.coinModule.currentObject.showPrice = util.showSpliceDecimal(kLineArray[kLineArray.length - 1][4], getPriceDecimal())
      const kLineList = kLineArray?.map((item) => {
        return {
          granularity,
          time: Number(item[0]),
          open: Number(item[1]),
          high: Number(item[2]),
          low: Number(item[3]),
          close: Number(item[4]),
          volume: Number(item[5]),
          amount: Number(item[6]),
        }
      })
      return kLineList as TSocketTradeKlineData
    },
    [Socket_Topic_Trade_Detail]: (data: TSocketResponse) => {
      return data.tradedetaillist.listList as TSocketTradeDetailData
    },
    [Socket_Market_Trade_Entrust_Change]: (data: TSocketResponse) => {
      return data.entrustvo
    },
    [Socket_Market_Trade_Asset_Balance]: (data: TSocketResponse) => {
      return data.userassetbalance
    },
  }
}

const createMessageDataHandler =
  (timezone: TTimezone = '') =>
  (data: any) => {
    const key = data.ch as TypeSocketKey
    const handlerData = getHandlerData(timezone)
    return handlerData[key]?.(data)
  }

const dynamicKeys = [
  Socket_Topic_Trade_Depth,
  Socket_Topic_Trade24h_tickers,
  Socket_Topic_Trade_KLINE,
  Socket_Topic_Trade_Detail,
].map((item) => {
  return {
    key: item,
    reg: new RegExp(
      `^${item
        .replace(/\./g, '\\.') // 转义所有的 "."
        .replace(/\{\{([^.]+)\}\}/g, '([^.]+)')}$`
    ),
  }
})

export const messageDataHandler = (data: any, { timezone: timezone = '' }) => {
  let key = data.ch as TypeSocketKey
  dynamicKeys.forEach((item) => {
    if (item.reg.test(key)) {
      key = item.key
    }
  })
  const handlerData = getHandlerData(timezone as TTimezone)
  return handlerData[key]?.(data)
}

/**
 * 替换模板字符串中的占位符
 * @param template 模板字符串
 * @param replacements 替换的实际值
 * @returns[string] 替换后的字符串
 * example: Socket_Topic_Trade_Depth
 * {
 *     symble: 'btc_usdt',
 *     depthNumber: 100
 * }
 */
export function replaceTradeSocketKey(
  template: string,
  replacements: { [key: string]: string | number | boolean }
): string {
  for (const [key, value] of Object.entries(replacements)) {
    const placeholder = `{{${key}}}`
    template = template.replace(new RegExp(placeholder, 'g'), value)
  }
  return template
}

export default createMessageDataHandler
